var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInboundCampaign01 = function SvgInboundCampaign01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "inbound_campaign-01_svg2__a",
    x1: 30.59,
    x2: 166.38,
    y1: 165.24,
    y2: 24.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M177.08 146.7a3.07 3.07 0 0 0-3.36-.67 3.08 3.08 0 0 0-1.91 2.85v5.51H61.84l-7.69-7.69a3.09 3.09 0 0 0-3.36-.67 3.07 3.07 0 0 0-1.9 2.85v5.26c-9.12-1.48-15.86-9.31-15.86-18.69 0-10.44 8.5-18.94 18.94-18.94h49.17l7.69 7.69c.87.87 2.23 1.14 3.36.67a3.07 3.07 0 0 0 1.9-2.85v-5.51h33.93c28.66 0 51.97-23.31 51.97-51.96s-23.31-51.97-51.97-51.97h-13.71l-7.69-7.69a3.06 3.06 0 0 0-3.36-.67 3.07 3.07 0 0 0-1.9 2.85v5.51H3.08c-1.7 0-3.08 1.38-3.08 3.08v26.86c0 1.7 1.38 3.08 3.08 3.08h118.29v5.51c0 1.25.75 2.37 1.9 2.85 1.13.47 2.5.19 3.36-.67l7.69-7.69h13.71c10.45 0 18.94 8.5 18.94 18.94s-8.5 18.94-18.94 18.94H114.1v-5.52c0-1.25-.75-2.37-1.9-2.85a3.06 3.06 0 0 0-3.36.67l-7.7 7.7H51.97C23.32 83.48.01 106.8.01 135.45s21.39 50.27 48.89 51.88v5.6c0 1.25.75 2.37 1.9 2.85 1.14.47 2.5.2 3.36-.67l7.69-7.69h109.97v5.51c0 1.25.75 2.37 1.9 2.85a3.072 3.072 0 0 0 3.36-.66l22.03-22.03c.58-.58.9-1.36.9-2.18s-.32-1.6-.9-2.18zh.01Zm-2.19 34.55H68.01l8.17-8.17c.58-.58.9-1.36.9-2.18s-.32-1.6-.9-2.18l-8.17-8.17h106.88c1.7 0 3.08-1.38 3.08-3.08v-1.15l14.59 14.59-14.59 14.58v-1.15c0-1.7-1.38-3.08-3.08-3.08Zm-122.92 0c-25.26 0-45.8-20.55-45.8-45.8s20.55-45.8 45.8-45.8h43l-8.16 8.17a3.09 3.09 0 0 0 0 4.36l8.17 8.17h-43c-13.85 0-25.11 11.26-25.11 25.1s11.27 25.1 25.11 25.1c1.7 0 3.08-1.38 3.08-3.08v-1.15l14.58 14.59-14.58 14.58v-1.15c0-1.7-1.38-3.08-3.08-3.08Zm59.05-91.59h37.02c13.85 0 25.11-11.26 25.11-25.1s-11.27-25.1-25.11-25.1h-7.55l8.17-8.17c.58-.58.9-1.36.9-2.18s-.32-1.6-.9-2.18l-8.17-8.17h7.55c25.26 0 45.8 20.55 45.8 45.8s-20.55 45.8-45.8 45.8h-37.02c-1.7 0-3.08 1.38-3.08 3.08v1.15l-14.58-14.58 14.58-14.58v1.16c0 1.7 1.38 3.08 3.08 3.08Zm13.43-50.22H6.17V18.75h118.29c1.7 0 3.08-1.38 3.08-3.08v-1.15l14.58 14.58-14.58 14.58v-1.15c0-1.7-1.38-3.08-3.08-3.08Z",
    style: {
      fill: "url(#inbound_campaign-01_svg2__a)"
    }
  }));
};
export default SvgInboundCampaign01;